import { Button, Spin } from 'antd';
import { useMemo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Images } from '../../config/images';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { maxShareCalculatorWithNoOfShare } from '../../utils/maxShareCalculator';
import { toastNotify } from '../../utils/toastNotify';
import './SMHeader.scss';

const SMHeader = (props) => {
  const { onNotifyClick, setIsSellOpen, propertyDetail } = props;
  const screenSM = useMediaQuery('(min-width: 640px)');
  const {
    loading,
    data: {
      data: {
        images = {},
        name = '',
        city = '',
        state = '',
        propertyTypeName = '',
        tag = '',
        propertyId = '',
        isSecondary = false,
        totalShare = 0,
        requestedShares = 0,
        userPurchaseDetail: { noOfShares = 0 } = {},
      } = {},
    } = {},
  } = useSelector((state) => state.propertyDetails);
  const userData = useSelector((state) => state.userData);
  const navigate = useNavigate();

  const notifyLoading = useSelector((state) => state.notifyMeSlice.loading);

  const isBuyDisabled = useMemo(() => {
    const sharesRemainingToPurchase = (Number(totalShare) * 9.8) / 100 - Number(noOfShares);
    return Number(sharesRemainingToPurchase) < 1;
  }, [noOfShares, totalShare]);

  return (
    <Spin spinning={loading}>
      <div className='smheader'>
        <div className='smheader__top top'>
          <div className='top__image'>
            <LazyLoadImage
              onError={(element) => {
                element.target.src = Images.noPropertyFoundImage;
              }}
              src={images?.[images?.primaryImage]}
              alt={name}
            />
          </div>
          <div className='top__data'>
            <h3>{name}</h3>
            <span className='text-taupe'>
              {city},{state} <span className='mr-4 ml-4 text-taupe-60'>•</span> {propertyTypeName}
            </span>
          </div>
          {!!screenSM && (
            <>
              {tag !== 'Coming Soon' ? (
                <div className='top__actions'>
                  <Button
                    onClick={() => {
                      setIsSellOpen('2');
                      Object.keys(userData?.userData).length > 0
                        ? userData?.userData?.isKYCVerified
                          ? props.clickAction('StepOne')
                          : !userData?.userData?.isKYCVerified
                          ? toastNotify('error', 'Please complete your kyc aml verification first.')
                          : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.')
                        : navigate('/login');
                    }}
                    disabled={Number(propertyDetail?.userPurchaseDetail?.noOfShares) <= 0}
                  >
                    Sell
                  </Button>
                  <Button
                    type='primary'
                    onClick={() => {
                      setIsSellOpen('1');
                      Object.keys(userData?.userData).length > 0
                        ? userData?.userData?.isKYCVerified
                          ? props.clickAction('StepOne')
                          : !userData?.userData?.isKYCVerified
                          ? toastNotify('error', 'Please complete all your verification steps first.')
                          : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.')
                        : navigate('/login');
                    }}
                    disabled={
                      isBuyDisabled ||
                      maxShareCalculatorWithNoOfShare(totalShare, requestedShares, propertyDetail?.userPurchaseDetail?.noOfShares) <= 0
                    }
                  >
                    Buy
                  </Button>
                </div>
              ) : (
                <div className='top__actions'>
                  <Button onClick={() => onNotifyClick({ id: propertyId, isSecondary: isSecondary })} loading={notifyLoading}>
                    Notify me
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
        {!screenSM && (
          <>
            {tag !== 'Coming Soon' ? (
              <Button
                className='w-100 mt-38'
                type='primary'
                onClick={() => {
                  Object.keys(userData?.userData).length > 0
                    ? userData?.userData?.isKYCVerified
                      ? props.clickAction('StepOne')
                      : !userData?.userData?.isKYCVerified
                      ? toastNotify('error', 'Please complete all your verification steps first.')
                      : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.')
                    : navigate('/login');
                }}
              >
                Trade
              </Button>
            ) : (
              <Button className='w-100 mt-38' onClick={() => onNotifyClick({ id: propertyId, isSecondary: isSecondary })} loading={notifyLoading}>
                Notify me
              </Button>
            )}
          </>
        )}
      </div>
    </Spin>
  );
};

export default SMHeader;
